// extracted by mini-css-extract-plugin
module.exports = {"plusMinus":"Faq_plusMinus__1HKGa","qstn":"Faq_qstn__t2rfy"};